import { useEffect, useState } from 'react';

export default function Navbar({ scrolled }: { scrolled: boolean }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled 
          ? 'bg-slate-900/95 backdrop-blur-lg border-b border-slate-700/50 shadow-lg' 
          : 'bg-slate-900/80 backdrop-blur-sm'
      }`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 flex items-center justify-center bg-slate-800 rounded-md border border-slate-700">
                <i className="ri-bar-chart-box-line text-slate-300 text-xl"></i>
              </div>
              <div>
                <div className="text-white font-bold text-lg leading-none tracking-wide">金門餐飲市場評估</div>
                <div className="text-slate-400 text-xs font-medium tracking-wider">KINMEN F&B MARKET ANALYSIS</div>
              </div>
            </div>

            {/* Navigation Links */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="#traffic-analysis" onClick={(e) => handleNavClick(e, '#traffic-analysis')} className="text-slate-300 hover:text-white text-sm font-medium transition-colors cursor-pointer">
                交通人流
              </a>
              <a href="#infrastructure" onClick={(e) => handleNavClick(e, '#infrastructure')} className="text-slate-300 hover:text-white text-sm font-medium transition-colors cursor-pointer">
                基礎建設
              </a>
              <a href="#entry-strategy" onClick={(e) => handleNavClick(e, '#entry-strategy')} className="text-slate-300 hover:text-white text-sm font-medium transition-colors cursor-pointer">
                進場策略
              </a>
              <a href="#conclusion" onClick={(e) => handleNavClick(e, '#conclusion')} className="text-slate-300 hover:text-white text-sm font-medium transition-colors cursor-pointer">
                投資結論
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-slate-300 cursor-pointer z-[60] relative pointer-events-auto"
              data-mobile-menu-btn
              aria-expanded={mobileMenuOpen}
              aria-label="選單"
            >
              <i className={`text-2xl transition-all ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Overlay */}
      <div 
        className={`mobile-overlay ${mobileMenuOpen ? 'is-open' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
      ></div>

      {/* Mobile Drawer */}
      <div className={`mobile-drawer ${mobileMenuOpen ? 'is-open' : ''}`} data-mobile-drawer>
        <div className="flex flex-col space-y-6">
          <div className="text-white font-bold text-lg mb-4 pb-4 border-b border-slate-700">
            快速導航
          </div>
          <a 
            href="#traffic-analysis" 
            onClick={(e) => handleNavClick(e, '#traffic-analysis')}
            className="text-slate-300 hover:text-white text-base font-medium transition-colors cursor-pointer flex items-center space-x-3"
          >
            <i className="ri-ship-line text-xl"></i>
            <span>交通人流</span>
          </a>
          <a 
            href="#infrastructure" 
            onClick={(e) => handleNavClick(e, '#infrastructure')}
            className="text-slate-300 hover:text-white text-base font-medium transition-colors cursor-pointer flex items-center space-x-3"
          >
            <i className="ri-building-line text-xl"></i>
            <span>基礎建設</span>
          </a>
          <a 
            href="#entry-strategy" 
            onClick={(e) => handleNavClick(e, '#entry-strategy')}
            className="text-slate-300 hover:text-white text-base font-medium transition-colors cursor-pointer flex items-center space-x-3"
          >
            <i className="ri-store-line text-xl"></i>
            <span>進場策略</span>
          </a>
          <a 
            href="#conclusion" 
            onClick={(e) => handleNavClick(e, '#conclusion')}
            className="text-slate-300 hover:text-white text-base font-medium transition-colors cursor-pointer flex items-center space-x-3"
          >
            <i className="ri-flag-line text-xl"></i>
            <span>投資結論</span>
          </a>
        </div>
      </div>
    </>
  );
}
